import type { Banner, Category, Item, MenuMode, MenuResponse } from './types';

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    headers: { 'content-type': 'application/json' },
    credentials: 'same-origin',
    ...init
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `HTTP ${res.status}`);
  }

  return res.json() as Promise<T>;
}

export const api = {
  getPublicMenu: (mode: MenuMode) => request<MenuResponse>(`/api/public/menu?mode=${mode}`),
  getAdminState: () => request<{ email: string; role: 'owner' | 'admin' }>(`/api/admin/state`),

  getCategories: () => request<{ categories: Category[] }>(`/api/admin/categories`),
  createCategory: (payload: Partial<Category>) =>
    request<{ ok: boolean; id: number }>(`/api/admin/categories`, {
      method: 'POST',
      body: JSON.stringify(payload)
    }),
  updateCategory: (id: number, payload: Partial<Category>) =>
    request<{ ok: boolean }>(`/api/admin/categories/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    }),
  deleteCategory: (id: number) =>
    request<{ ok: boolean }>(`/api/admin/categories/${id}`, { method: 'DELETE' }),

  getItems: () => request<{ items: Item[] }>(`/api/admin/items`),
  createItem: (payload: Partial<Item> & { tags?: string[] }) =>
    request<{ ok: boolean; id: number }>(`/api/admin/items`, {
      method: 'POST',
      body: JSON.stringify(payload)
    }),
  updateItem: (id: number, payload: Partial<Item> & { tags?: string[] }) =>
    request<{ ok: boolean }>(`/api/admin/items/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    }),
  deleteItem: (id: number) => request<{ ok: boolean }>(`/api/admin/items/${id}`, { method: 'DELETE' }),

  getBanners: () => request<{ banners: Banner[] }>(`/api/admin/banners`),
  createBanner: (payload: Partial<Banner>) =>
    request<{ ok: boolean; id: number }>(`/api/admin/banners`, {
      method: 'POST',
      body: JSON.stringify(payload)
    }),
  updateBanner: (id: number, payload: Partial<Banner>) =>
    request<{ ok: boolean }>(`/api/admin/banners/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    }),
  deleteBanner: (id: number) => request<{ ok: boolean }>(`/api/admin/banners/${id}`, { method: 'DELETE' })
};
